import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { verifyPayment, paymentDone } from "../../actions/index";

const queryString = require("query-string");

class PaymentSuccess extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      is_valid: ""
    };
  }

  componentDidMount() {
    if (this.props.location.search) {
      const parsed = queryString.parse(this.props.location.search);
      this.props.verifyPayment(parsed);
      this.props.paymentDone(parsed);
    }
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.paymentVerification.is_valid !==
      prevProps.paymentVerification.is_valid
    ) {
      this.setState({
        is_valid: this.props.paymentVerification.is_valid
      });
    }
  }

  render() {
    console.log(this.state.is_valid);

    if (this.state.is_valid === true) {
      return <Redirect to={"/thanks"} />;
    } else if (this.state.is_valid === false) {
      return <Redirect to={"/fail"} />;
    } else {
      return <div className={"loading"}>Loading....</div>;
    }
  }
}

const mapStateToProps = function(store) {
  return {
    invoices: store.invoices.invoices,
    locale: store.locale,
    paymentVerification: store.paymentVerification
  };
};

const mapDispatchToProps = dispatch => ({
  verifyPayment: id => dispatch(verifyPayment(id)),
  paymentDone: data => dispatch(paymentDone(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(PaymentSuccess);



// WEBPACK FOOTER //
// ./src/containers/Payment/Success.js